module.exports = "https://web-assets.ifttt.com/packs/media/layout/icon-settings-fe225fb0.svg";